import * as React from 'react';
import { memo } from 'react';
const SvgThicknessThick = (props) => (
  <svg width={168} height={128} viewBox="0 0 168 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-83.3042 68.413L-95.1992 56.518L120.614 -147.4L-83.3042 68.413ZM-73.4843 78.4115L-61.5893 90.3065L142.329 -125.507L-73.4843 78.4115ZM-39.7048 112.019L-51.5999 100.124L164.221 -103.801L-39.7048 112.019ZM-17.9034 133.821L-29.7984 121.926L186.022 -81.9995L-17.9034 133.821ZM13.8082 165.525L25.7032 177.42L229.622 -38.393L13.8082 165.525ZM3.90173 155.621L-7.99327 143.726L207.82 -60.1926L3.90173 155.621ZM273.214 5.20102L57.4004 209.119L69.2954 221.014L273.214 5.20102ZM47.4975 199.213L35.6025 187.318L251.416 -16.6005L47.4975 199.213Z"
      fill="#51574E"
    />
  </svg>
);
const Memo = memo(SvgThicknessThick);
export default Memo;
